import React from "react";
import { I18n } from "i18n-js";
import * as locales from "../../locales.json";
const i18n = new I18n(locales);
i18n.defaultLocale = "en";
i18n.locale = (window as any).locale || "";

export default class FeedbackFooter extends React.Component<any, any> {
  render() {
    return (
      <>
        <div className="rewards-footer">
          <div className="feedback-disclaimer alert-warning on-white-background">
            <b>
              {i18n.translate("new_feature.beta_feedbacks.disclaimer.bold")}
            </b>
            &nbsp;
            {i18n.translate(
              "new_feature.beta_feedbacks.disclaimer.instructions"
            )}
            &nbsp;
            <a
              href="#"
              data-toggle="modal"
              data-target={`#${this.getModalId()}`}
            >
              {i18n.translate("new_feature.beta_feedbacks.disclaimer.cta")}
            </a>
          </div>
        </div>
      </>
    );
  }

  getModalId = () => {
    return "beta-feedback-modal";
  };
}
